<div class="modalPreviewContent" [class.portal-attached]="attached" id="modalPreviewContent"></div>
<div class="panel-options" [class.portal-attached]="attached">
    <div spPanelDragHandler class="panel-options-handler" [class.portal-attached]="attached">
        <!-- <img src="./assets/img/websites/lpc-dnd-icon.svg" /> -->
        <span class="sp-icon icon-drag-drop"> </span>
    </div>

    <ng-content select="web-settings-breadcrumbs"></ng-content>
    <ng-content></ng-content>
</div>
